import React, {Component} from 'react'
import utils from "../../utils/utils";
import {connect} from "react-redux";
import {addNewPatient} from "../../redux/actions/Tabs-Actions";
import validationHelper from "../../utils/validationHelper";
import AlertConfirm from "../../components/modals/Confirm";
import TabsDashboard from "./PatientOnboardTabs/TabsDashboard";
import doctorApi from "../../services/ApiServices/doctorApi";
import {makeError} from "../../components/modals/ErrorModal";
import {history} from "../../utils/history";
import {authenticationService} from "../../services/AuthenticationService";
import {withTranslation} from "react-i18next";
import {compose} from "redux";


class PatientVisitConnected extends Component {

    constructor(props) {
        super(props);
        this.state = {
            entry: {
                Phone_num1: "",
                Last_name: "",
                First_name: "",
                Phone_num2: "",
                House_number: "",
                Email: null,
                ID_passport: "",
                receiving_asaya_system_assisted: "",
            },
            patientInfo: {},
            checkboxes: {},
            symptoms: [],
            medicalConditionsSelected: [],
            addedProducts: [],
            choosenTargetsSymptoms: [],
            negativeSymptoms: [],
            errors: {},
            currentView: 1,
            errorsOnSave: {},
            isOtherPsychiatricDiagnosis: false,
            isOtherPastUseMedication: false,
            pastUseOtherMedication: false,
            validationSchema: null,
            patientDetails: {},
            allergics: [],
            patient_allergics: [],
            allHCPs: [],
            general_medications: [],
            bloodThinner_medications: [],
            currentPain_medications: [],
            past_med: [],
            medications_conditions: [],
            titrationPlan: {},
            titrationPlans: [],
            medicationsList: [],
            productsList: [],
            symptomsList: [],
            nextVisitDoc: [],
            nextVisitDocSelected: [],
            medical_diagnose_icd: [],
            patientTreatments: [],
            addedFilesList: [],
            fileForms: [],
            psychiatric_diagnose_icd: [],
            israelCities: [],
            editMode: false,
            loading: true,
            medicalConditions: [],
            isUploadingFiles: false,
            hasNewVisit: false,
            visitAdded: false,
            profilePic: null,
            errorOnSave: "no"
        }
    }

    setCurrentView(view) {
        this.setState({currentView: view})
    }

    componentWillReceiveProps(nextProps) {

    }

    async componentDidMount() {
        let {
            symptoms, entry, patientInfo, addedProducts, medicalConditionsSelected, medical_diagnose_icd,
            general_medications, bloodThinner_medications, currentPain_medications, past_med, patientTreatments,
            medications_conditions, addedFilesList, psychiatric_diagnose_icd, editMode, negativeSymptoms, allHCPs,
            profilePic, patient_allergics, titrationPlans, allergics, productsList, israelCities, medicalConditions,
            fileForms, medicationsList, nextVisitDoc, symptomsList, hasNewVisit, visitAdded
        } = this.state


        let allData = this.props.location.state.allData
        if (allData) {
            titrationPlans = allData.titrationPlans
            allergics = allData.allergics
            productsList = allData.products
            israelCities = allData.cities
            medicalConditions = allData.medicalConditions
            fileForms = allData.forms
            medicationsList = allData.medications
            nextVisitDoc = allData.docs
            symptomsList = allData.symptoms
            medical_diagnose_icd = allData.medical_diagnose_icd
            psychiatric_diagnose_icd = allData.psychiatric_diagnose_icd
            allHCPs = allData.hcps
        }

        await this.setState({
            productsList, titrationPlans, medicalConditions, fileForms, medicationsList, symptomsList,
            medical_diagnose_icd, psychiatric_diagnose_icd, israelCities, nextVisitDoc, allHCPs, allergics
        })

        editMode = !!this.props.location.state.patientInfo
        let nextVisitDocSelected = []

        if (editMode) {
            patientInfo = this.props.location.state.patientInfo ? this.props.location.state.patientInfo : {}

            profilePic = patientInfo.profilePicUrl
            hasNewVisit = patientInfo.hasNewVisit

            let patient_requests = patientInfo.Patient_requests ? patientInfo.Patient_requests : []

            let cannabis_patient = patientInfo.cannabis_patient
            let PII = patientInfo.PII

            if (PII.Date_of_birth) {
                PII.Date_of_birth = new Date(PII.Date_of_birth)
            }

            let requestID
            if (patient_requests.length > 0) {
                patientInfo = patient_requests[0]
                requestID = patientInfo.RequestID
            }

            let patient_conditions = patientInfo.Patient_conditions ? patientInfo.Patient_conditions : ""
            let Habits_Medicals = patientInfo.Habits_Medicals && patientInfo.Habits_Medicals.length > 0 ? patientInfo.Habits_Medicals[0] : []
            addedProducts = patientInfo.Patient_products ? patientInfo.Patient_products : []

            let pAllergics = Habits_Medicals['patient_allergics'] ? Habits_Medicals.patient_allergics : ""
            pAllergics = pAllergics ? pAllergics.split(',') : ""

            patient_allergics = []
            for (let i = 0; i < pAllergics.length; i++) {
                let index = parseInt(pAllergics[i])
                patient_allergics.push({value: index, label: this.getAllergicDesc(index, "")})
            }


            let Patient_type_indication = patientInfo.Patient_type_indications && patientInfo.Patient_type_indications.length > 0 ? patientInfo.Patient_type_indications[0] : {}


            let nextVisitDocSelectedArr = Patient_type_indication['Patient_next_visit_documents'] ? Patient_type_indication.Patient_next_visit_documents : ""
            nextVisitDocSelectedArr = nextVisitDocSelectedArr !== "" ? nextVisitDocSelectedArr.split(',') : ""

            for (let i = 0; i < nextVisitDocSelectedArr.length; i++) {
                let index = parseInt(nextVisitDocSelectedArr[i])
                nextVisitDocSelected.push({value: index, label: this.getDocSelected(index)})
            }

            let medications = patientInfo.Patient_Medications ? patientInfo.Patient_Medications : []
            let isOtherPastUseMedication = false

            for (let i = 0; i < medications.length; i++) {
                if (medications[i].General_Thinner_Past === "Past") {
                    if (medications[i].Medication_name === "Other") {
                        isOtherPastUseMedication = true
                    }
                    past_med.push({value: parseInt(medications[i].Med_ID), label: medications[i].Medication_name})
                } else {
                    let medObj = {value: medications[i].Med_ID, label: medications[i].Medication_name}
                    medications[i].MedObj = medObj
                    if (medications[i].General_Thinner_Past === "G") {
                        medications[i].index = general_medications.length
                        general_medications.push(medications[i])
                    } else if (medications[i].General_Thinner_Past === "T") {
                        medications[i].index = bloodThinner_medications.length
                        bloodThinner_medications.push(medications[i])
                    } else if (medications[i].General_Thinner_Past === "CP") {
                        medications[i].index = currentPain_medications.length
                        currentPain_medications.push(medications[i])
                    }
                }

            }
            medications_conditions = patientInfo.medications_conditions ? patientInfo.medications_conditions : []


            patientTreatments = patientInfo.Patient_treatments ? patientInfo.Patient_treatments : []

            patientTreatments = this.handlePatientTreatments(patientTreatments)
            this.setState({past_med, isOtherPastUseMedication, patientTreatments})

            entry = {...Habits_Medicals, ...PII, ...Patient_type_indication, ...patientInfo, RequestID: requestID}
            entry['cannabis_patient'] = cannabis_patient

            if (entry.Birth_country === "Israel") {
                entry.BornInIsrael = "Yes"
            }


            let allSymptoms = patientInfo.Patient_symptoms && !hasNewVisit ? patientInfo.Patient_symptoms : []
            let tCount = 0
            let nCount = 0
            let hCount = 0

            for (let i = 0; i < addedProducts.length; i++) {
                addedProducts[i]['product_use_obj'] = {
                    value: addedProducts[i].product_use,
                    label: addedProducts[i].product_use
                }
                addedProducts[i].displayProducts = this.onclickChoosedCategory(addedProducts[i].product_use_category, addedProducts[i].product_type)
            }

            for (let i = 0; i < patient_conditions.length; i++) {
                medicalConditionsSelected.push({
                    value: parseInt(patient_conditions[i].Condition_ID),
                    label: this.getConditionDesc(patient_conditions[i].Condition_ID, "")
                })
            }

            for (let i = 0; i < allSymptoms.length; i++) {
                if (allSymptoms[i].H_N_T === "T") {
                    allSymptoms[i].Symptom_ID = tCount + allSymptoms[i].Symptom_ID
                    tCount += 1
                    symptoms.push(allSymptoms[i])
                } else if (allSymptoms[i].H_N_T === "N") {
                    allSymptoms[i].Symptom_ID = nCount + allSymptoms[i].Symptom_ID
                    nCount += 1
                    negativeSymptoms.push(allSymptoms[i])
                    let negSymp = allSymptoms[i].Patient_symptom_index + "-negativeSymptom"
                    entry[negSymp] = true
                }
            }

            let medICD = {value: "", label: ""}
            let anotherMedICD = {value: "", label: ""}
            let psychiatricMedICD = {value: "", label: ""}
            for (let i = 0; i < psychiatric_diagnose_icd.length; i++) {
                if (psychiatric_diagnose_icd[i].ICD_diagnosis_id === parseInt(entry.psychiatric_diagnoses_icd_name)) {
                    psychiatricMedICD.label = psychiatric_diagnose_icd[i].Diagnosis_description
                    psychiatricMedICD.value = psychiatric_diagnose_icd[i].ICD_diagnosis_id
                }
            }
            for (let i = 0; i < medical_diagnose_icd.length; i++) {
                if (medical_diagnose_icd[i].ICD_diagnosis_id === parseInt(entry.medical_diagnoses_icd_name)) {
                    medICD.label = medical_diagnose_icd[i].Diagnosis_description
                    medICD.value = medical_diagnose_icd[i].ICD_diagnosis_id
                }
                if (medical_diagnose_icd[i].ICD_diagnosis_id === parseInt(entry.Another_Medical_diagnoses_icd_name)) {
                    anotherMedICD.label = medical_diagnose_icd[i].Diagnosis_description
                    anotherMedICD.value = medical_diagnose_icd[i].ICD_diagnosis_id
                }
            }

            entry.medical_diagnoses_icd_name = medICD
            entry.Another_Medical_diagnoses_icd_name = anotherMedICD
            entry.psychiatric_diagnoses_icd_name = psychiatricMedICD

            if (!hasNewVisit || visitAdded) {
                addedFilesList = await doctorApi.getAllUploadedFiles(entry.UserStorageID, requestID)
                addedFilesList = addedFilesList ? addedFilesList.data : []
            }


            /*            profilePic = await doctorApi.getProfilePic(entry.UserStorageID)
                        profilePic = profilePic ? profilePic.data.Form_url : null*/

            entry.SelectedCity = {value: entry.cityID, label: this.getCityDesc(entry.cityID)}

        } else {
            let id = await doctorApi.getPatientID()
            entry['UserStorageID'] = id ? id.data : ""
        }


        this.setState({
            symptoms,
            patientInfo,
            profilePic,
            hasNewVisit,
            addedProducts,
            medicalConditionsSelected,
            medical_diagnose_icd,
            medications_conditions,
            entry,
            general_medications,
            bloodThinner_medications,
            currentPain_medications,
            addedFilesList,
            loading: false,
            editMode,
            nextVisitDocSelected,
            psychiatric_diagnose_icd,
            patient_allergics,
            isOtherPsychiatricDiagnosis: entry.Another_Medical_diagnoses_icd_name
        })

        /*
                await this.initValidation(this.state.validationSchema)
        */

    }

    getCityDesc = (val) => {
        let {israelCities} = this.state
        for (let j = 0; j < israelCities.length; j++) {

            if (israelCities[j].index.toString() === val) {
                return israelCities[j].cityName
            }
        }
    }

    handlePatientTreatments(patientTreatments) {
        for (let i = 0; i < patientTreatments.length; i++) {
            let arr = []
            let symptomsID = patientTreatments[i].Symptom_ID ? patientTreatments[i].Symptom_ID : ""
            let choosenSymptoms = Array.isArray(symptomsID) ? symptomsID : symptomsID.split("/")
            let patientSymptoms = this.state.symptoms

            choosenSymptoms.map(item => {
                if (patientSymptoms.length === 0) {
                    arr = []
                } else {
                    for (let i = 0; i < patientSymptoms.length; i++) {
                        if (patientSymptoms[i].Symptom_ID === parseInt(item)) {
                            arr.push(parseInt(item))
                        }
                    }
                }
            })

            patientTreatments[i].Symptom_ID = arr
            /*  if (patientTreatments[i].Titration_code === "New") {
                  this.getNewTitrationPlan(i)
              } else {
                  this.getTitrationPlan(patientTreatments[i].Titration_code, i)
              }*/
        }
        return patientTreatments
    }

    getDocSelected(index) {
        let {nextVisitDoc} = this.state
        for (let i = 0; i < nextVisitDoc.length; i++) {
            if (index === nextVisitDoc[i].index) {
                return nextVisitDoc[i].FromDoctor
            }
        }
    }

    initValidation = async (schema) => {
        let {t} = this.props
        let {entry, editMode} = this.state
        let validationSchema = schema

        let errors = await validationHelper.validate(entry, validationSchema)

        this.setState({
            validationSchema,
            errors
        })
    }

    onclickSetIsOtherMedicalDiagnosis = () => {
        this.setState({isOtherPsychiatricDiagnosis: !this.state.isOtherPsychiatricDiagnosis})
    }

    onclickSetProfilePic = (value) => {
        this.setState({profilePic: value})
    }


    onNavBack = async (val) => {
        let confirm = await AlertConfirm({
            options: {
                title: `Withdraw edit Patient's data`,
            }
        }, `Are you sure you want to withdraw the new patient's data?`)
        if (confirm) {
            this.props.history.goBack()
        }
    }

    onValueChange = async (name, value) => {
        let {entry, validationSchema} = this.state
        if (name === "Email" && value === "") {
            value = null
        }
        utils.set(entry, name, value)
        // let entryValidator = utils.removeEmptyOrNull(entry)
        let entryValidator = entry

        let errors = await validationHelper.validate(entryValidator, validationSchema);
        let errorsOnSave = this.state.errorsOnSave;

        if (JSON.stringify(errors) === '{}') {
            errorsOnSave = errors
        }

        if (utils.get(errorsOnSave, name)) {
            utils.set(errorsOnSave, name, utils.get(errors, name))
        }

        this.setState({
            entry,
            errors,
            errorsOnSave
        })
    }

    onClickCheckboxes = async (name) => {
        let {checkboxes} = this.state
        if (checkboxes.hasOwnProperty(name)) {
            checkboxes[name] = !checkboxes[name]
        } else checkboxes[name] = true

        this.onValueChange(name, checkboxes[name])
        this.setState({checkboxes})
    }


    getAllergicDesc = (index, lang) => {
        let {allergics} = this.state
        let currentUser = authenticationService.currentUserValue;
        let language = lang ? lang : localStorage.getItem('language')
        for (let j = 0; j < allergics.length; j++) {
            if (allergics[j].index === index) {
                if (language === "he") {
                    return allergics[j].Allergic_name_he
                } else {
                    return allergics[j].Allergic_name
                }
            }
        }
    }
    getConditionDesc = (conditionID, lang) => {
        let {medicalConditions} = this.state
        let currentUser = authenticationService.currentUserValue;
        let language = lang ? lang : localStorage.getItem('language')
        for (let j = 0; j < medicalConditions.length; j++) {
            if (medicalConditions[j].Condition_ID.toString() === conditionID.toString()) {
                if (language === "he") {
                    return medicalConditions[j].Condition_description_he
                } else {
                    return medicalConditions[j].Condition_description
                }
            }
        }
    }
    getSymptomsDesc = (Symptom_ID, lang) => {
        let {symptomsList} = this.state
        let currentUser = authenticationService.currentUserValue;
        let language = lang ? lang : localStorage.getItem('language')
        for (let j = 0; j < symptomsList.length; j++) {
            if (symptomsList[j].Symptom_ID.toString() === Symptom_ID) {
                if (language === "he") {
                    return symptomsList[j].Symptom_description_he
                } else {
                    return symptomsList[j].Symptom_description
                }
            }
        }
    }


    removeSymptomFromTreatment() {
        let patientTreatments = this.state.patientTreatments
        let targetSymptoms = this.state.symptoms
        let current = []
        if (patientTreatments.length > 0) {
            for (let i = 0; i < patientTreatments.length; i++) {
                current = patientTreatments[i].Symptom_ID
                if (current) {
                    for (let b = 0; b < current.length; b++) {
                        let exists = false
                        if (targetSymptoms.length > 0) {
                            for (let j = 0; j < targetSymptoms.length; j++) {
                                let id = targetSymptoms[j].Symptom_ID ? targetSymptoms[j].Symptom_ID : ""
                                if (String(current[b]) === id.substring(1)) {
                                    exists = true
                                }
                            }
                        }
                        if (!exists) {
                            current.splice(b, 1)
                        }
                    }
                    patientTreatments[i].Symptom_ID = current
                }
            }
        }
        this.setState({patientTreatments})

    }

    onClickTargetSymptom = (Symptom_ID, event, id) => {
        let {symptoms, symptomsList} = this.state
        let symptomChanged = false
        for (let i = 0; i < symptoms.length; i++) {
            if (symptoms[i].Symptom_ID) {
                if (symptoms[i].Symptom_ID === Symptom_ID) {
                    if (event === "SymptomsInputSelect") {
                        symptomChanged = symptoms[i].Symptom_ID ? true : false
                        symptoms[i].Symptom_ID = [i] + id
                        symptoms[i].Symptom_description = this.getSymptomsDesc(id, "")
                    } else if (event === "Suffer_duration") {
                        symptoms[i].Suffer_duration = id
                    } else if (event.includes("SymptomLine")) {
                        symptoms[i].Symptom_rating = id
                    } else if (event.includes("Influence")) {
                        symptoms[i].Intensity = id
                    } else if (event.includes("OtherSymptom")) {
                        symptoms[i].OtherSymptom = id
                    }
                }
                if (event === "Symptom_is_primary" && symptoms[i].Symptom_ID === Symptom_ID) {
                    if (!symptoms[i].Symptom_is_primary)
                        symptoms[i].Symptom_is_primary = id
                } else if (event === "Symptom_is_primary") {
                    symptoms[i].Symptom_is_primary = ""
                }

            } else {
                if (event === "SymptomsInputSelect") {
                    symptoms[i].Symptom_ID = [i] + id
                    symptoms[i].Symptom_description = this.getSymptomsDesc(id, "")

                }
            }
        }
        this.setState({symptoms})

        if (symptomChanged) {
            this.removeSymptomFromTreatment()
        }
    }

    onClickMedicationConditions = (conditionsList) => {
        this.setState({medicalConditionsSelected: conditionsList})
    }

    onclickChoosedCategory(category, type) {
        let {productsList} = this.state
        let displayProducts = []
        for (let i = 0; i < productsList.length; i++) {
            if ((category === productsList[i].Category && productsList[i].Strain === "Flower")
                || (category === productsList[i].Category && productsList[i].Strain === type)) {
                displayProducts.push(
                    {value: productsList[i].Product_name, label: productsList[i].Product_name})
            }
        }
        return displayProducts
    }

    onYesNoValueChange(variable, value) {
        let {entry} = this.state
        if (entry[variable] === value) {
            this.onValueChange(variable, "")
        } else {
            this.onValueChange(variable, value)
        }
    }

    onClickAddProducts = async (func, value, index) => {
        let {addedProducts} = this.state
        let {t} = this.props

        let tempEntry = {}
        if (func === "ADD") {
            if (addedProducts.length === 4) {
                let confirm = await AlertConfirm({
                    options: {
                        title: '',
                    }
                }, t('patient_boarding.maxProd'))
            } else {
                tempEntry.index = addedProducts.length
                tempEntry.product_type = "Flower"
                tempEntry.product_use_category = ""
                tempEntry.product_use = ""
                tempEntry.displayProducts = []
                addedProducts.push(tempEntry)
            }
        } else if (func === "product_use_category") {
            addedProducts[index].product_use_category = value
            addedProducts[index].displayProducts = this.onclickChoosedCategory(value, addedProducts[index].product_type)
        } else if (func === "Delete") {
            addedProducts.splice(0, addedProducts.length)
        } else if (func === "product_use_obj") {
            addedProducts[index][func] = value
            addedProducts[index]['product_use'] = value.label

        } else {
            addedProducts[index][func] = value
        }
        this.setState({addedProducts})
    }

    async addDeleteTargetSymptom(name) {
        let {symptoms} = this.state
        if (name === "Add") {
            if (symptoms.length < 3) {
                symptoms.push({Symptom: "Symptom"})
                this.setState({symptoms})
            } else {
                let confirm = await AlertConfirm({
                    options: {
                        title: ``,
                    }
                }, `Note that you can add max 3 symptoms`)
            }
        } else {
            const index = symptoms.indexOf(name);
            if (index > -1) {
                symptoms.splice(index, 1);
                this.setState({symptoms})
            }
        }

    }

    onClickAddDeleteMedications = (index, event, id, type) => {
        let {
            currentPain_medications,
            bloodThinner_medications,
            general_medications,
            past_med,
            isOtherPastUseMedication
        } = this.state
        let medications = []
        if (type === "CP") {
            medications = currentPain_medications
        } else if (type === "GEN") {
            medications = general_medications
        } else if (type === "BT") {
            medications = bloodThinner_medications
        }
        if (id === "Med_ID") {
            medications[event]['Med_ID'] = index.value
            medications[event]['Medication_name'] = index.label
            medications[event]['MedObj'] = index
        } else if (id === "past_med") {
            let indexOther = index.find((obj => obj.label === "Other"));
            this.onValueChange("PastUseOtherMed", " ")
            isOtherPastUseMedication = indexOther ? true : false
            this.setState({past_med: index, isOtherPastUseMedication})
        } else {
            medications[index][id] = event
        }
        if (type === "CP") {
            this.setState({currentPain_medications: medications, isOtherPastUseMedication})
        } else if (type === "GEN") {
            this.setState({general_medications: medications, isOtherPastUseMedication})
        } else if (type === "BT") {
            this.setState({bloodThinner_medications: medications, isOtherPastUseMedication})
        }
    }

    addDeleteMedication(func, index) {
        let {currentPain_medications, general_medications, bloodThinner_medications} = this.state
        if (func === "addGen") {
            general_medications.push({index: index, General_Thinner_Past: "G"})
        } else if (func === "addThinner") {
            bloodThinner_medications.push({index: index, General_Thinner_Past: "T"})
        } else if (func === "addCP") {
            currentPain_medications.push({index: index, General_Thinner_Past: "CP"})
        } else if (func === "deleteCP") {
            currentPain_medications.splice(index, 1)
        } else if (func === "deleteThinner") {
            bloodThinner_medications.splice(index, 1)
        } else if (func === "deleteGen") {
            general_medications.splice(index, 1)
        }
        this.setState({general_medications, bloodThinner_medications, currentPain_medications})
    }

    historyBackToDashboard = () => {
        history.push({
            pathname: `/dashboard`,
            state: {
                from: {
                    fromPath: `/dashboard`,
                }
            },
        })
    }

    backToDashboard = async () => {
        let {t} = this.props
        let backtoPatient = t('patient_boarding.Back_patient_page')
        let backtoPatientMessage = t('patient_boarding.Back_patient_page_message') + "?"
        let backtoDashboard = t('patient_boarding.Back_patient_dashboard')
        let backtobacktoDashboardMessage = t('patient_boarding.Back_patient_dashboard_message') + "?"

        let {editMode} = this.state
        let backTitle = editMode ? backtoPatient : backtoDashboard
        let backText = editMode ? backtoPatientMessage : backtobacktoDashboardMessage
        let proceedLabel = t('patient_boarding.proceedLabel')
        let cancelLabel = t('patient_boarding.cancelLabel')
        let confirm = await AlertConfirm({
            options: {
                proceedLabel: proceedLabel,
                cancelLabel: cancelLabel,
                title: backTitle,
            }
        }, backText)

        if (confirm && editMode) {
            this.saveAllPatientData("exit")
        } else if (confirm) {

            this.savePatient("exit")

        } else {
            this.setState({entry: {}})
            this.props.history.goBack()
        }
    }


    addFileObj = async (index, selectedCategory, selectedFile) => {
        this.setState({isUploadingFiles: true})
        let {addedFilesList, entry} = this.state
        if (selectedFile !== "" && selectedCategory !== "") {
            let fileToAdd = {
                index: index,
                selectedCategory: selectedCategory,
                selectedFile: selectedFile.value,
                file: selectedFile.files,
                UserStorageID: entry.UserStorageID,
                RequestID: entry.RequestID
            }
            let response = await doctorApi.getUploadedFile(fileToAdd)
            if (response) {
                addedFilesList.push(response.data[0])
            }
        }
        this.setState({addedFilesList, isUploadingFiles: false})
    }

    deleteUploadedFile = async (index) => {
        this.setState({isUploadingFiles: true})
        let {addedFilesList, entry} = this.state
        let fileToDelete = addedFilesList[index]
        let res = await doctorApi.deleteUploadedFiles(entry.UserStorageID, fileToDelete)
        if (res) {
            if (addedFilesList.length === 1) {
                addedFilesList = []
            } else {
                addedFilesList.splice(index, 1)
            }
        }
        this.setState({addedFilesList, isUploadingFiles: false})
    }

    getErrors = async () => {
        let errors = ""
        errors = await validationHelper.validate(this.state.entry, this.state.validationSchema)
        return errors
    }


    saveAllPatientData = async (value) => {
        this.setState({loading: true});
        /*
                await this.initValidation(this.state.validationSchema)
        */
        let {
            entry,
            symptoms,
            nextVisitDocSelected,
            patient_allergics,
            past_med,
            general_medications,
            currentPain_medications,
            bloodThinner_medications,
            negativeSymptoms,
            checkboxes,
            medicalConditionsSelected,
            addedProducts,
            hasNewVisit,
            visitAdded,
            patientTreatments
        } = this.state

        let errors = await validationHelper.validate(this.state.entry, this.state.validationSchema)
        let {t} = this.props
        let Couldnt_save_patient = t('patient_boarding.Couldnt_save_patient')
        let Couldnt_save_patient_message = t('patient_boarding.Couldnt_save_patient_message')
        if (!utils.isEmpty(errors)) {
            this.setState({errorsOnSave: this.state.errors, errors: this.state.errors, loading: false});
            await makeError({
                proceedLabel: t('patient_boarding.ok'),
                options: {
                    title: Couldnt_save_patient,
                }
            }, [Couldnt_save_patient_message]);
            return;
        }

        let allergics = ""
        if (patient_allergics) {
            for (let i = 0; i < patient_allergics.length; i++) {
                allergics = i === 0 ? patient_allergics[i].value : allergics + "," + patient_allergics[i].value
            }
        }

        let Patient_next_visit_documents = ""
        if (nextVisitDocSelected) {
            for (let i = 0; i < nextVisitDocSelected.length; i++) {
                Patient_next_visit_documents = i === 0 ? nextVisitDocSelected[i].value.toString() : Patient_next_visit_documents + ","
                    + nextVisitDocSelected[i].value.toString()
            }
        }


        entry = {...entry, ...checkboxes}

        entry.patient_allergics = allergics
        entry.Patient_next_visit_documents = Patient_next_visit_documents

        entry.medical_diagnoses_icd_name = entry.medical_diagnoses_icd_name?.value ? entry.medical_diagnoses_icd_name.value : ""
        entry.Another_Medical_diagnoses_icd_name = entry.Another_Medical_diagnoses_icd_name?.value ? entry.Another_Medical_diagnoses_icd_name.value : ""
        entry.psychiatric_diagnoses_icd_name = entry.psychiatric_diagnoses_icd_name?.value ? entry.psychiatric_diagnoses_icd_name.value : ""


        let medications = []

        medications = medications.concat(general_medications, currentPain_medications, bloodThinner_medications)

        for (let i = 0; i < past_med.length; i++) {
            let a = {Med_ID: past_med[i].value, Medication_name: past_med[i].label, General_Thinner_Past: "Past"}
            medications.push(a)
        }

        entry['LastVisitDate'] = (new Date())
        entry['hasNewVisit'] = hasNewVisit
        entry['visitAdded'] = visitAdded
        entry['symptoms'] = symptoms ? symptoms : []
        entry['medicalConditionsSelected'] = medicalConditionsSelected ? medicalConditionsSelected : []
        entry['medications'] = medications
        entry['Patient_products'] = addedProducts
        entry['Patient_treatments'] = patientTreatments
        entry['isFormFullyFilled'] = true
        entry['IsRequest'] = false

        if (!hasNewVisit || (hasNewVisit && visitAdded)) {
            entry['RequestID'] = entry.RequestID
        } else {
            delete entry.RequestID;
        }

        entry.DeclarationAccept = false
        entry.AcceptFutureContact = false


        if (entry.Phone_num1 && !entry.Phone_num1.includes('972')) {
            entry.Phone_num1 = "972" + entry.Phone_num1.substring(1)
            this.onValueChange("Phone_num1", entry.Phone_num1)
        }


        let response = await doctorApi.PatientVisit(entry, entry.UserStorageID)
        if (response && response.data) {
            visitAdded = true
            let request = response.data.Patient_requests ? response.data.Patient_requests : []
            this.onValueChange("RequestID", response.data.RequestID)
            this.onValueChange("requestDate", response.data.requestDate)

        }

        this.setState({loading: false, errorOnSave: response, visitAdded});

        let title = t('patient_boarding.Data_Saved')
        let message = t('patient_boarding.Continue_patient_boarding')

        if (response && value === "exit") {
            this.historyBackToDashboard()
        } else if (response && value === "save") {
            let confirm = await AlertConfirm({
                options: {
                    title: title,
                }
            }, message)
            if (!confirm) {
                this.setState({entry: {}})
                this.historyBackToDashboard()
            }
        } else {
            return response
        }
    }

    getTitrationPlan = async (value, index) => {

        let {titrationPlan, titrationPlans} = this.state

        if (value === "New") {
            this.editTreatmentPlan("Titration_code", value, index)
            this.editTreatmentPlan("TreatmentInitialDose", "", index)
            this.editTreatmentPlan("Treatment_Maximum_dosage", "", index)
            this.editTreatmentPlan("titrationPlan", "", index)
            this.editTreatmentPlan("TreatmentStepUpEvery", "", index)

        } else {
            for (let i = 0; i < titrationPlans.length; i++) {

                if (titrationPlans[i].Titration_code === value) {
                    titrationPlan = titrationPlans[i].Titration_steps
                    this.editTreatmentPlan("Titration_code", value, index)
                    this.editTreatmentPlan("titrationPlan", titrationPlan, index)
                    this.editTreatmentPlan("TreatmentInitialDose", titrationPlans[i].Initial_dose, index)
                    this.editTreatmentPlan("Treatment_Maximum_dosage", titrationPlans[i].Maximum_daily_dose, index)
                    this.editTreatmentPlan("TreatmentStepUpEvery", 3, index)
                }
            }
        }
    }

    editTreatmentPlan = async (func, value, index) => {
        let {patientTreatments} = this.state
        let currentIndex = index
        patientTreatments.map((item, index) => {
            if (index !== currentIndex) {
                patientTreatments[index]["isExpanded"] = false
            } else {
                patientTreatments[index]["isExpanded"] = true
            }
        })
        if (func === "Symptom_ID") {
            if (patientTreatments[index].Symptom_ID) {
                let choosenTargetsSymptoms = patientTreatments[index].Symptom_ID
                let found = 0
                let indexArr = 0
                for (let i = 0; i < choosenTargetsSymptoms.length; i++) {
                    if (choosenTargetsSymptoms[i] === value) {
                        found = +1
                        indexArr = i
                    }
                }
                if (found > 0) {
                    choosenTargetsSymptoms.splice(indexArr, 1);
                } else {
                    choosenTargetsSymptoms.push(value)
                }
                patientTreatments[index].Symptom_ID = choosenTargetsSymptoms
            } else {
                patientTreatments[index].Symptom_ID = [value]
            }
        } else if (func === "TreatmentMonthlyDosage" && value !== "Other") {
            patientTreatments[index][func] = value
            patientTreatments[index]["TreatmentMonthlyDosageOther"] = 0
        } else {
            patientTreatments[index][func] = value

            if (patientTreatments[index].Titration_code === "New") {
                this.getNewTitrationPlan(index)
            }

        }
        this.setState({patientTreatments})
    }

    getNewTitrationPlan(index) {
        let {patientTreatments} = this.state
        let indexPlan = 0
        let plan = []

        for (let i = parseInt(patientTreatments[index].TreatmentInitialDose); i <= parseInt(patientTreatments[index].Treatment_Maximum_dosage); i++) {
            let currentDose = parseInt(patientTreatments[index].TreatmentInitialDose) + indexPlan
            plan.push({M: currentDose.toString(), E: currentDose.toString(), N: currentDose.toString()})
            indexPlan += 1
        }
        patientTreatments[index]['titrationPlan'] = plan

        this.setState({patientTreatments})

    }

    async DeleteTreatment(index) {
        let {patientTreatments} = this.state
        let {t} = this.props

        let title = t('patient_boarding.delete_treatment')
        let message = t('patient_boarding.delete_treatment_message')
        let confirm = await AlertConfirm({
            options: {
                title: title,
            }
        }, message)
        if (confirm) {
            patientTreatments.splice(index, 1)
            this.setState({patientTreatments})
        }

    }

    async getRecommendedTreatment() {
        this.setState({loading:true})
        let {entry,medicalConditionsSelected,symptoms} = this.state
        let {t} = this.props
        let indication = entry.patient_indication

        let age = this.getPatientAge(entry.Date_of_birth)

        let diabetes = medicalConditionsSelected.findIndex( obj => obj.value.toString() ==="11")
        let high_hp = medicalConditionsSelected.findIndex( obj => obj.value.toString() ==="15")
        let alzheimerCond = medicalConditionsSelected.findIndex( obj => obj.value.toString() ==="3")
        let parkinsonCond = medicalConditionsSelected.findIndex( obj => obj.value.toString() ==="22")

        let parikson=indication === t('patient_boarding.Neurology_Parkinson')||parkinsonCond>-1
        || entry.medical_diagnoses_icd_code==="G20"||entry.Another_Medical_diagnoses_icd_code==="G20"? 1 : 0
        let alzheimer=indication === t('patient_boarding.Alzheimer')||alzheimerCond>-1
            || entry.medical_diagnoses_icd_code==="G30"||entry.Another_Medical_diagnoses_icd_code==="G30"? 1 : 0


        let oncology= indication === t('patient_boarding.Oncology_chemotherapy')
            || entry.medical_diagnoses_icd_code==="Z51.1"||entry.Another_Medical_diagnoses_icd_code==="Z51.1"? 1 : 0

        let primarySymptomIndex,secondarySymptomIndex
        for (let i = 0; i < symptoms.length; i++) {
            if(symptoms[i].Symptom_is_primary === "on"){
                primarySymptomIndex=i
            }else{
                secondarySymptomIndex=i
            }
        }

        let SymptomsArr=[]
         symptoms.map(item=> {
             SymptomsArr.push({
                 Symptom_ID:item.Symptom_ID.substring(0),
                 Symptom_is_primary: item.Symptom_is_primary && item.Symptom_is_primary==="on"?1:0,
                 Symptom_rating:item.Symptom_rating?parseInt(item.Symptom_rating.substring(item.Symptom_rating.length-1)):null
             })
            })

        let recommendTreatments = []

        let data = {
            "Cannabis_Naive": entry.Smoked_cannabis === "YesPast" || entry.Smoked_cannabis === "No" ? 1 : 0,
            "Intensity_score_over5": 1,
            "Tourette": indication === t('patient_boarding.Neurology_Gilles') ? 1 : 0,
            "Last_treatment": 0,
            "Age_over65": age>65?1:0,
            "Diabetes": diabetes>-1?1:0,
            "High_BP": high_hp>-1?1:0,
            "Alzheimer": alzheimer,
            "Parkinson": parikson,
            "Palliative":  indication === t('patient_boarding.Palliative_care') ? 1 : 0,
            "Oncology": oncology,
            "symptoms":SymptomsArr
        }

        let {titrationPlans}=this.state
        let response = await doctorApi.getRecommendedTreatment(data)
        if(response){
            let data = response.data.data
            if(data && !data.errorType){
                Object.entries(data).forEach(([key, value]) => {
                    if(key.includes("Plan")){
                        let indexTit = titrationPlans.findIndex(item=> item.Titration_template_ID === value.Titration)
                        let schedule = value.Schedule
                        schedule= schedule ==="Asneeded"?"As needed":schedule
                        recommendTreatments.push({TreatmentCategory:value.THC_CBD,TreatmentSchedule:schedule,Titration_code:indexTit>=0?titrationPlans[indexTit].Titration_code:""})

                    }
                 });
            }
        }
        if(recommendTreatments.length>0){
            this.replaceTreatments(recommendTreatments)
        }

        this.setState({loading:false})

    }

    async replaceTreatments(treatmentArr) {
        let {t} = this.props
        let newTreatmentArr=[]
        for (let i = 0; i < treatmentArr.length; i++) {
            let newTreatment = {...treatmentArr[i],isExpanded: i===0}
            newTreatment.index = newTreatmentArr.length
            if (newTreatmentArr.length < 4) {
                newTreatmentArr.push(newTreatment)
            } else {
                await makeError({
                    proceedLabel: t('patient_boarding.ok'),
                }, [t('patient_boarding.maxTreatments')]);
                return;
            }
        }

        this.setState({patientTreatments:newTreatmentArr})
    }

    async addTreatmentPlan(data) {
        let {t} = this.props
        let {patientTreatments, choosenTargetsSymptoms} = this.state
        let targetsSymptoms = data?{...data,isExpanded: true}:{isExpanded: true}
        targetsSymptoms.index = patientTreatments.length
        patientTreatments.map(item => item.isExpanded = false)
        if (patientTreatments.length < 4) {
            patientTreatments.push(targetsSymptoms)
        } else {
            await makeError({
                proceedLabel: t('patient_boarding.ok'),
            }, [t('patient_boarding.maxTreatments')]);
            return;
        }
        this.setState({patientTreatments})
    }

    onClickPatientAllergics(event) {
        this.setState({patient_allergics: event})
    }

    onChangeNextVisitDocChange(option) {
        let {nextVisitDocSelected} = this.state
        nextVisitDocSelected = option
        this.setState({nextVisitDocSelected})

    }

    savePatient = async (val) => {
        let {t} = this.props
        let Couldnt_save_patient = t('patient_boarding.Couldnt_save_patient')
        let Couldnt_save_patient_message = t('patient_boarding.Couldnt_save_patient_message')

        let errors = await validationHelper.validate(this.state.entry, this.state.validationSchema)

        if (!utils.isEmpty(this.state.errors)) {
            this.setState({errorsOnSave: this.state.errors});
            await makeError({
                proceedLabel: t('patient_boarding.ok'),
                options: {
                    title: Couldnt_save_patient,
                }
            }, [Couldnt_save_patient_message]);
            return;
        }
        let {entry} = this.state

        entry['LastVisitDate'] = (new Date())


        if (entry.Phone_num1 && !entry.Phone_num1.includes('972')) {
            entry.Phone_num1 = "972" + entry.Phone_num1.substring(1)
            this.onValueChange("Phone_num1", entry.Phone_num1)
        }

        let response = await doctorApi.newPatient(entry)
        if (response) {
/*
            this.props.addNewPatient(response.data)
*/
            entry.UserStorageID = (response.data.UserStorageID)
            if (response && !entry.RequestID) {
                this.onValueChange("RequestID", response.data.RequestID)
            }
            this.setState({entry: entry, editMode: true})
            if (val === "exit") {
                this.historyBackToDashboard()

            }
        }
    }

    getPatientAge(birthday) {
        if (birthday !== null) {
            let todayDate = new Date().toISOString()
            let todayExactDate = (todayDate.split('T'))[0].split('-')
            let currentYear = todayExactDate[0]
            let currentMonth = todayExactDate[1]
            let birthDate = birthday ? birthday.toISOString() : ""
            let exactDate = (birthDate.split('T'))[0].split('-')
            let yearDiff = currentYear - exactDate[0]
            let monthDiff = currentMonth - exactDate[1]
            if (monthDiff < 0) {
                return (yearDiff - 1) + "." + (12 + monthDiff)
            } else {
                return yearDiff + "." + (monthDiff)
            }
        }
        return ""
    }

    render() {
        let {errorsOnSave, errors, entry, editMode} = this.state
        let {t} = this.props
        let id = editMode && entry.ID_passport ? entry.ID_passport : ""
        let PatientName = editMode ? entry.First_name + ' ' + entry.Last_name + ' ' : t('patient_boarding.adding_patient')

        let backText = editMode ? t('patient_boarding.back_patient') : t('patient_boarding.back_dashboard')

        if (this.state.loading) {
            return <div className="loader"/>
        }

        let gender = entry.Gender
        let currentUser = authenticationService.currentUserValue;
        let language = localStorage.getItem('language')
        if (language === "he") {
            gender = gender === "Female" ? "נקבה" : gender
            gender = gender === "Male" ? "זכר" : gender
            gender = gender === "Specified" ? "לא ידוע" : gender
        }

        let age = this.getPatientAge(entry.Date_of_birth)
        return (

            <div>
                <div className={'asaya-info-PatientVisit'}>
                    <div className={'adminMargin-title'}>
                        <div style={{display: 'flex', width: '84%'}}>
                            <label className="NewLeumitPatientTitle3">{PatientName}</label>
                            <div>
                                <label className="NewLeumitPatientTitle">{t('patient_boarding.id_number')}</label>
                                <label className="NewLeumitPatientTitleValue">{id}</label>
                            </div>
                            <div className={"title_splash"}/>
                            <div>
                                <label className="NewLeumitPatientTitle">{t('patient_boarding.age')}</label>
                                <label className="NewLeumitPatientTitleValue">{age}</label>
                            </div>
                            <div className={"title_splash"}/>
                            <div>
                                <label className="NewLeumitPatientTitle">{t('patientPage.Gender')}</label>
                                <label className="NewLeumitPatientTitleValue">{gender}</label>
                            </div>

                        </div>

                        {/* <div style={{display: 'flex', width: '80%'}}>
                            <label className="NewPatientTitle">{PatientName}</label>
                            <label className="NewPatientTitle2">{id}</label>
                            <label className="NewPatientTitle2">{age}</label>
                        </div>*/}
                        <label className={'BackToPatientPage'} onClick={() => this.backToDashboard()}>
                            {backText}</label>
                    </div>
                </div>
                <div className={'Patient-Screen'}>
                    <div className={'adminMargin-patientOnboard'}>

                        <TabsDashboard onValueChange={(name, value) => this.onValueChange(name, value)}
                                       motherClass={this}
                                       savePatient={() => this.savePatient()}
                                       getErrors={() => this.getErrors()}
                                       isUploadingFiles={this.state.isUploadingFiles}
                                       profilePic={this.state.profilePic}
                                       addTreatmentPlan={() => this.addTreatmentPlan()}
                                       getRecommendedTreatment={() => this.getRecommendedTreatment()}
                                       onclickSetIsOtherMedicalDiagnosis={() => this.onclickSetIsOtherMedicalDiagnosis()}
                                       onclickSetProfilePic={(value) => this.onclickSetProfilePic(value)}
                                       onChangeNextVisitDocChange={(option) => this.onChangeNextVisitDocChange(option)}
                                       saveAllPatientData={(value) => this.saveAllPatientData(value)}
                                       onClickPatientAllergics={(value) => this.onClickPatientAllergics(value)}
                                       initValidation={(schema) => this.initValidation(schema)}
                                       onClickCheckboxes={(name) => this.onClickCheckboxes(name)}
                                       onClickTargetSymptom={(Symptom_ID, name, id) => this.onClickTargetSymptom(Symptom_ID, name, id)}
                                       onClickAddDeleteMedications={(index, event, id, type) => this.onClickAddDeleteMedications(index, event, id, type)}
                                       addDeleteMedication={(func, index) => this.addDeleteMedication(func, index)}
                                       onNavBack={() => this.onNavBack()}
                                       addDeleteTargetSymptom={(name) => this.addDeleteTargetSymptom(name)}
                                       addFileObj={(index, selectedCategory, selectedFile) => this.addFileObj(index, selectedCategory, selectedFile)}
                                       deleteUploadedFile={(index) => this.deleteUploadedFile(index)}
                                       DeleteTreatment={(index) => this.DeleteTreatment(index)}
                                       onClickMedicationConditions={(conditions) => this.onClickMedicationConditions(conditions)}
                                       onClickAddProducts={(func, value, index) => this.onClickAddProducts(func, value, index)}
                                       editTreatmentPlan={(func, value, index) => this.editTreatmentPlan(func, value, index)}
                                       getSymptomsDesc={(Symptom_ID, lang) => this.getSymptomsDesc(Symptom_ID, lang)}
                                       getAllergicDesc={(index, lang) => this.getAllergicDesc(index, lang)}
                                       getConditionDesc={(conditionID, lang) => this.getConditionDesc(conditionID, lang)}
                                       setCurrentView={(view) => this.setCurrentView(view)}
                                       medications_conditions={this.state.medications_conditions}
                                       getTitrationPlan={(val, index) => this.getTitrationPlan(val, index)}
                                       symptoms={this.state.symptoms}
                                       allergics={this.state.allergics}
                                       allHCPs={this.state.allHCPs}
                                       medicalConditionsSelected={this.state.medicalConditionsSelected}
                                       addedProducts={this.state.addedProducts}
                                       israelCities={this.state.israelCities}
                                       onYesNoValueChange={(name, value) => this.onYesNoValueChange(name, value)}
                                       titrationPlans={this.state.titrationPlans}
                                       choosenTargetsSymptoms={this.state.choosenTargetsSymptoms}
                                       addedFilesList={this.state.addedFilesList}
                                       currentView={this.state.currentView}
                                       medicalConditions={this.state.medicalConditions}
                                       fileForms={this.state.fileForms}
                                       entry={this.state.entry}
                                       general_medications={this.state.general_medications}
                                       bloodThinner_medications={this.state.bloodThinner_medications}
                                       currentPain_medications={this.state.currentPain_medications}
                                       past_med={this.state.past_med}
                                       isOtherPastUseMedication={this.state.isOtherPastUseMedication}
                                       patientTreatments={this.state.patientTreatments}
                                       checkboxes={this.state.checkboxes}
                                       editMode={this.state.editMode}
                                       isOtherPsychiatricDiagnosis={this.state.isOtherPsychiatricDiagnosis}
                                       errorsOnSave={errorsOnSave}
                                       errors={errorsOnSave}
                                       medicationsList={this.state.medicationsList}
                                       patient_allergics={this.state.patient_allergics}
                                       productsList={this.state.productsList}
                                       medical_diagnose_icd={this.state.medical_diagnose_icd}
                                       psychiatric_diagnose_icd={this.state.psychiatric_diagnose_icd}
                                       symptomsList={this.state.symptomsList}
                                       nextVisitDoc={this.state.nextVisitDoc}
                                       nextVisitDocSelected={this.state.nextVisitDocSelected}
                                       errorOnSave={this.state.errorOnSave}
                                       titrationPlan={this.state.titrationPlan}/>
                    </div>
                </div>
            </div>

        )
    }

}

function mapDispatchToProps(dispatch) {
    return {
        addNewPatient: patientData => dispatch(addNewPatient(patientData)),
    };
}

const mapStateToProps = state => {
    return {
        patientsData: state.patientsTableDataReducer.patientsData
    };
};

const PatientVisit = compose(
    withTranslation(),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(PatientVisitConnected)

export default PatientVisit;
